"use client";
import { AssetSvg as e } from "../AssetSvg.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { useId as r } from "react";
//#region src/components/assets/artwork/REFlag24Artwork.tsx
var i = (i) => {
	let a = r();
	return /* @__PURE__ */ n(e, {
		viewBox: "0 0 24 24",
		fill: "none",
		...i,
		children: [/* @__PURE__ */ n("g", {
			clipPath: `url(#${a}-clip0_103_194)`,
			children: [
				/* @__PURE__ */ t("mask", {
					id: `${a}-path-1-inside-1_103_194`,
					fill: "white",
					children: /* @__PURE__ */ t("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ t("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ t("path", {
					d: "M-6 0H6V24H-6V0Z",
					fill: "#00318A"
				}),
				/* @__PURE__ */ t("path", {
					d: "M18 0H30V24H18V0Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", {
			id: `${a}-clip0_103_194`,
			children: /* @__PURE__ */ t("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
};
//#endregion
export { i as REFlag24Artwork };
